<app-header
    *ngIf="!(_router.url === '/pages-register' || _router.url.includes('/payment?') || _router.url === '/login'|| _router.url === '/signin'|| _router.url.includes('/loginWithToken') || _router.url === '/pages-error404' || _router.url === '/')"></app-header>
<app-sidebar
    *ngIf="!(_router.url === '/pages-register' || _router.url.includes('/payment?') || _router.url === '/login'|| _router.url === '/signin'|| _router.url.includes('/loginWithToken')  || _router.url === '/pages-error404' || _router.url === '/')"></app-sidebar>

<loader></loader>
<router-outlet></router-outlet>
<app-footer *ngIf="!(_router.url.includes('/payment?'))"></app-footer>

<!-- <app-footer *ngIf="!(_router.url === '/pages-register' || _router.url === '/login' || _router.url === '/pages-error404' || _router.url === '/')" ></app-footer> -->

<!-- <div class="w-100">
  <div
    class="modal modal-lg fade"
    id="session-timeout-login"
    tabindex="-1"
    role="dialog"
    aria-labelledby="session-timeout-login"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      id="modal-dialog"
    >
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">Your session has timed out</span>
        </div>
        <div class="modal-body">
          <div class="my-1 mx-3">Enter credentials to continue</div>
          <form name="myForm" [formGroup]="loginform">
            <div class="row">
              <div class="col-12 col-md-10 offset-md-1">
                <div class="form-group">
                  <div class="col-12">
                    Email<span style="color: red">*</span>
                  </div>
                  <input
                    type="text"
                    name="username"
                    class="form-control shadow border-1"
                    id="yourUsername"
                    style="border-color: #142a49"
                    formControlName="username"
                    placeholder="Email"
                    [ngClass]="{
                      'is-invalid': submitted && f['username'].errors
                    }"
                  />
                  <div
                    *ngIf="submitted && f['username'].errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f['username'].errors['required']">
                      Email is required
                    </div>
                    <div
                      *ngIf="
                        f['username'].errors && f['username'].errors['pattern']
                      "
                    >
                      Please enter valid email
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-10 offset-md-1 mt-2">
                <div class="form-group">
                  <div class="col-12">
                    Password<span style="color: red">*</span>
                  </div>
                  <input
                    name="password"
                    [type]="showPassword"
                    class="form-control shadow border-1"
                    formControlName="password"
                    style="border-color: #142a49"
                    id="yourPassword"
                    placeholder="Password"
                    [ngClass]="{
                      'is-invalid': submitted && f['password'].errors
                    }"
                  />
                  <i
                    [class]="fafaEye"
                    class="fafaEyes"
                    (click)="togglePasswordVisibility()"
                  ></i>
                  <div
                    *ngIf="submitted && f['password'].errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f['password'].errors['required']">
                      Password is required
                    </div>
                    <div *ngIf="f['password'].errors['minlength']">
                      Password must be at least 8 characters
                    </div>
                    <div *ngIf="f['password'].errors['maxlength']">
                      Password must not exceed 40 characters
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button
            type="button"
            class="btn btn-sm btn-light"
            id="updateButton"
            (click)="onSubmit()"
          >
            <b>Login</b>
          </button>
        </div>
      </div>
    </div>
  </div>
</div> -->
